import { useAuth0, User } from '@auth0/auth0-react'
import { useMemo } from 'react'

import { isUserCategory, UserCategory, userClaimIds } from '../utils/userClaims'

export interface UseUserCategory {
  userCategory: UserCategory | undefined
  parseUserCategory: (user: User | undefined) => UserCategory | undefined
}

export const parseUserCategory = (userToParse: User | undefined): UserCategory | undefined => {
  const userCategory = userToParse ? (userToParse[userClaimIds.category] as unknown) : undefined
  return isUserCategory(userCategory) ? userCategory : undefined
}

const useUserCategory = (): UseUserCategory => {
  const { user } = useAuth0()

  const userCategory = useMemo(() => parseUserCategory(user), [user])
  return {
    userCategory,
    // TODO remove usages to import function directly. Returning for now for backwards
    //  compatibility, even though is not owned by the hook
    parseUserCategory,
  }
}

export default useUserCategory
